var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('div',{ref:_vm.refName},[(_vm.validSurvey)?_c('survey',{attrs:{"survey":_vm.survey}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }